var _mask, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 22,
    viewBox: "0 0 13 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2734_27207",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.98456 1.87951L12.95 0V14.3708L12.0345 14.5435V6.19355L2.98456 1.87951Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.98456 1.87951L12.95 0V14.3708L12.0345 14.5435V6.19355L2.98456 1.87951Z",
    fill: "#9E523B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.95 0L12.3939 -2.94803L15.95 -3.6187V0H12.95ZM2.98456 1.87951L1.69365 4.58756L-6.59957 0.63422L2.42856 -1.06852L2.98456 1.87951ZM12.95 14.3708H15.95V16.8579L13.506 17.3188L12.95 14.3708ZM12.0345 14.5435L12.5905 17.4915L9.03445 18.1622V14.5435H12.0345ZM12.0345 6.19355L13.3254 3.4855L15.0345 4.30021V6.19355H12.0345ZM13.506 2.94803L3.54057 4.82753L2.42856 -1.06852L12.3939 -2.94803L13.506 2.94803ZM9.94995 14.3708V0H15.95V14.3708H9.94995ZM11.4784 11.5954L12.3939 11.4228L13.506 17.3188L12.5905 17.4915L11.4784 11.5954ZM9.03445 14.5435V6.19355H15.0345V14.5435H9.03445ZM10.7435 8.9016L1.69365 4.58756L4.27548 -0.828543L13.3254 3.4855L10.7435 8.9016Z",
    fill: "#9E523B",
    mask: "url(#path-1-inside-1_2734_27207)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41089 19.3381V8.29435L1.98714 4.73441V15.7781L9.41089 19.3381Z",
    fill: "#FD9879",
    stroke: "#FD9879",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCover);
export default __webpack_public_path__ + "static/media/cover.d71cc92575c7e9d72b89635671368fab.svg";
export { ForwardRef as ReactComponent };